import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';

export default class ClienteTipoPedidoB2BEmpresaValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;
        let assClienteTipoPedido = model;

        if (!assClienteTipoPedido.idCliente) {
            refs.empresaInput.focusedOut = true;
            validated = false;
            this.showMessage(new Message('alert', 'necessario-cliente', true))
        }
        if (!assClienteTipoPedido.idTipoPedido) {
            refs.tipoPedidoInput.focusedOut = true;
            validated = false;
            this.showMessage(new Message('alert', 'msg-necessario-tipo-pedido', true))
        }

        return validated;
    }

}